export default __webpack_public_path__ + "static/media/pool-vehicle-gray.12738e04.svg";